import './StatementEdition.css';
import Dropdown from '../../../../../../components/UI/DropDown/DropDown';
import StatementMessageType from '/src/features/editor/data/constant/types/StatementMessageType';
import ReactTextareaAutosize from 'react-textarea-autosize';
import Button from '/src/components/UI/Button/Button';
import { useState, useEffect } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import VariableDropdown from '../../../Variables/VariablesDropdown/VariablesDropdown';
import useSpeechSynthesis from '/src/hooks/useSpeechSynthesis';
import useSpeechToText from '/src/hooks/useSpeechToText';
import Sound from 'jsx:../../../../image/sound-max.svg';
import SoundMute from 'jsx:../../../../image/sound-mute.svg';
import Microphone from 'jsx:../../../../image/microphone-sound-on.svg';
import MicrophoneOff from 'jsx:../../../../image/microphone-sound-off.svg';
function StatementEdition({ type, content, index, onClose }) {

    const [typeValue, setTypeValue] = useState(type ? type : 'text');
    const data = { text: '', raw: '' };
    data[typeValue] = content ? content : '';
    const title = content ? 'Update Statement' : 'Create Statement';
    const [contentValue, setContentValue] = useState(data);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [bracketIsMissing, setBracketIsMissing] = useState(false);
    const [parenthesisIsMissing, setParenthesisIsMissing] = useState(false);
    const [hookIsMissing, setHookIsMissing] = useState(false);
    const [voices, speak, speaking] = useSpeechSynthesis();
    const { transcript, listening, toggleListening } = useSpeechToText();

    const setContentValueKey = (key, value) => {
        setBracketIsMissing(!checkElement("{","}", value))
        setParenthesisIsMissing(!checkElement("(",")", value))
        setHookIsMissing(!checkElement("[", "]",value))
        setContentValue({ ...contentValue, [key]: value })
    }

    const checkElement = (elementleft,elementRight, value) =>{
        let nbLeftElement = value.split('').filter(letter => letter.toLowerCase() == elementleft).length
        let nbRightElement = value.split('').filter(letter => letter.toLowerCase() == elementRight).length
        return nbLeftElement == nbRightElement
    }

    const modal = useModal()

    const disableSpellCheck = (ref) => {
        if (!ref) {
            return;
        }
        ref.spellcheck = false
    }

    const handleClickSpeak = () => {
        if (contentValue && contentValue.text !== "") {
            // const voicesFilterByLanguage = voices.filter(voice => voice.lang ==="US");
            // const voice = voicesFilterByLanguage.filter(voice => voice.default).shift() || voicesFilterByLanguage.shift();
            speak(contentValue.text);
        }
    }

    const checkValidation = (value) => {
        return value.length == 0
    }

    const onClick = () => {
        if (typeValue === "text") {
            setContentValueKey(typeValue, transcript ? transcript : contentValue[typeValue]);
            toggleListening(false);
            modal.resolve({ index, data: { type: typeValue, content: transcript ? transcript : contentValue[typeValue] } });
        } else {
            modal.resolve({ index, data: { type: typeValue, content: contentValue[typeValue] } });
        }

        return onClose();
    }

    useEffect(() => {
        setIsSpeaking(speaking ? true : false)
    }, [speaking]);

    const placeholders = {
        text: 'Statement content',
        telephony: 'Test Telephony',
        media: 'Media url (ex: https://www.images.com/robot.png)',
        slideshow: 'Media url (ex: https://www.images.com/robot.png; https://www.images.com/robot1.png)'
    }

    return (
        <div className='statement_modal'>
            <label className='title'>{title}</label>
            <div className='area-edit'>
                <div className='grid-row'>
                    <label className="dropdown_title">Type of Statement : </label>
                    <div className='dropdown_container'>
                        <Dropdown choices={StatementMessageType} setValue={(name, value) => setTypeValue(value)} defaultChoice={typeValue} />
                    </div>
                </div>

                {typeValue == 'text' ? <><div className='grid-row' style={{ marginLeft: '-15px' }}>
                    <label className="dropdown_title">Insert Variable : </label>
                    <div className='dropdown_container variable_container'>
                        <VariableDropdown createVariableDisable={true} width="200px" noChangeOnSelect={true} setValue={(name, value) => {
                            if (value == null) {
                                return;
                            }
                            value = "[" + value.name.toUpperCase() + "]"
                            setContentValueKey(typeValue, contentValue[typeValue].length ? contentValue[typeValue] + ' ' + value : value)
                        }} />
                    </div>
                </div></> : null}

                <div className='statement_content'>
                    <ReactTextareaAutosize ref={(ref) => disableSpellCheck(ref)} value={contentValue[typeValue]} onChange={(e) => setContentValueKey(typeValue, e.target.value)} style={{ border: bracketIsMissing || parenthesisIsMissing || hookIsMissing ? '2px solid red' : "" }} className="input editor-input title_input" placeholder={placeholders[typeValue]} minRows={4} />
                    {type != 'raw' ?
                        <>
                            <div onClick={handleClickSpeak} >
                                {isSpeaking ?
                                    <Sound className={`speaking-button ${checkValidation(contentValue[typeValue]) ? 'disabled-icon' : 'enabled-icon'}`} /> :
                                    <SoundMute className={`speaking-button ${checkValidation(contentValue[typeValue]) ? 'disabled-icon' : 'enabled-icon'}`} />
                                }
                            </div>
                            <div onClick={toggleListening} >
                                {listening ? <Microphone className='record-button' /> : <MicrophoneOff className='record-button' />}
                            </div>
                        </> : ''}
                    <div style={{marginLeft: "10%", marginTop: "5px"}}>
                        <div style={{height : "30px", color :"var(--pink)"}}> {bracketIsMissing || parenthesisIsMissing || hookIsMissing ? "An element is missing : [ · { · (" : ""}</div>
                    </div>
                </div>
            </div>
            <Button label="Confirm" disabled={checkValidation(contentValue[typeValue]) || (bracketIsMissing || parenthesisIsMissing || hookIsMissing)}  onClick={onClick} />
        </div>
    )
}

export default StatementEdition